import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
import productTileTemplate from '../../sections/collection/productTileTemplateNosto';
import { debounce } from '../../core/helpers';

// Select same color or 1st one available
// Add the "more colors" link
// Remove the out of stock colors
// Show / Hide Plus colors depending on Fit selection
const initColor = (formatted_products) => {
  // Remove out of stock colors
  formatted_products.forEach(product => {
    product.variants.forEach(variant => {
      if (
        typeof variant.online_inventory_style === 'undefined' ||
        variant.online_inventory_style === 0 ||
        variant.online_inventory_style === null
      ) {
        document.querySelectorAll(
          `[data-complete-look-products] [data-product-id="${product.id}"] [data-color-value="${variant.color}"]`
        ).forEach(el => el.remove());
      }
    });
  });

  // Get selected color handle
  let selected_color_handle = '';
  if (document.querySelector('[data-product-details]')) {
    const activeColor = document.querySelector('[data-product-overview] [data-product-option-color].active');
    if (activeColor) {
      selected_color_handle = activeColor.dataset.colorHandle;
    }
  }

  // Iterate product tiles
  document.querySelectorAll('[data-complete-look-products] [data-product-tile]').forEach(item => {
    const swatches = item.querySelectorAll('[data-color-swatch]');
    if (!swatches.length) return;

    if (selected_color_handle === '') {
      swatches[0].click();
    } else {
      const selectedSwatch = item.querySelector(`[data-color-swatch][data-color-handle="${selected_color_handle}"]`);
      // console.log('selected_color_handle selectedSwatch', selected_color_handle, selectedSwatch, swatches[0]);
      if (selectedSwatch) {
        selectedSwatch.click();
      } else {
        swatches[0].click();
      }
    }

    // Add staging attribute if needed
    if (window.Shopify.shop.includes('staging')) {
      swatches.forEach(swatch => swatch.setAttribute('data-staging-swatch', ''));
    }
  });
};

// Keep same height elements to keep them aligned
const sameHeight = () => {
  // Remove inline styles
  document.querySelectorAll('[data-complete-look-products] [data-product-tile-title]').forEach(el => el.style.removeProperty('height'));
  document.querySelectorAll('[data-complete-look-products] [data-product-tile-price]').forEach(el => el.style.removeProperty('height'));

  let title_height = 0;
  let price_height = 0;

  document.querySelectorAll('[data-complete-look-products] [data-product-tile]').forEach(item => {
    const titleEl = item.querySelector('[data-product-tile-title]');
    const priceEl = item.querySelector('[data-product-tile-price]');
    const item_title_height = titleEl ? titleEl.offsetHeight : 0;
    const item_price_height = priceEl ? priceEl.offsetHeight : 0;

    if (item_title_height > title_height) title_height = item_title_height;
    if (item_price_height > price_height) price_height = item_price_height;
  });

  document.querySelectorAll('[data-complete-look-products] [data-product-tile]').forEach(item => {
    const titleEl = item.querySelector('[data-product-tile-title]');
    const priceEl = item.querySelector('[data-product-tile-price]');
    if (titleEl) titleEl.style.height = `${title_height}px`;
    if (priceEl) priceEl.style.height = `${price_height}px`;
  });
};

export default async () => {
  if (!document.querySelector('[data-complete-look-ids-json]') || !document.querySelector('[data-complete-the-look]')) {
    return;
  }

  const complete_look_gql_ids = JSON.parse($('[data-complete-look-ids-json]').html());
  const complete_look_ids = complete_look_gql_ids.map(gql_id => Number(gql_id.replace('gid://shopify/Product/', '')));
  // console.log('complete_look_ids', complete_look_ids);

  let products = await loadProductsByID(complete_look_ids, false, false, true, true, false, true, true);

  // Remove the non-available products
  products = products.filter(product => product.available === true);

  if (products.length === 0) {
    const look_el = document.querySelector('[data-complete-the-look]');
    if (look_el) {
      look_el.remove();
    }

    return;
  }

  console.log('[ASTR] Complete the look API products', products);

  // Reformat product data based on Nosto format
  const products_tiles_html = products.map((product) => `
    ${productTileTemplate({
      'name': product.title,
      'url': product.url,
      'product_id': product.id,
      'price': Number(product.variants[0].price / 100.0),
      'price_text': String(product.variants[0].price / 100.0),
      'image_url': product.images.length ? product.images[0] : null,
      'custom_fields': {
        'astr-swatches': product.swatches_raw,
        'astr-images_details': product.images_raw,
        'stamped-reviews_average': product.stamped_average,
        'bestseller_style_30': product.bestseller_30,
        'bestseller_style_14': product.bestseller_14,
      },
      'skus': product.variants.map(variant => ({
        name: variant.title,
        id: String(variant.id),
        available: variant.available,
        price: Number(variant.price),
        image_url: variant.image,
        custom_fields: {
          'Color': variant.color,
          'astr-plus_size': variant.style_flag_plus,
        }
      }))
    }, {
      is_slider: false,
      is_simplified: true,
      has_swatches: true,
      has_quickview: true,
      is_search: false,
      is_lookbook: false,
      enable_price_conversion: false,
      has_animations: false,
    }, false)}
  `).join('');

  const products_container = document.querySelector('[data-complete-look-products]');
  if (products_container) {
    products_container.innerHTML = products_tiles_html;
    products_container.dataset.totalItems = products.length;

    if (products.length > 2) {
      products_container.classList.add('mobile-scrollable');
    }
  }

  window.setTimeout(() => {
    initColor(products);
    sameHeight();
  }, 1500); // Crazy wait for the tiles to be rendered
  
  // ADA: keypress for color swatches
  document.querySelectorAll('[data-complete-look-products] [data-color-swatch]').forEach(swatch => {
    swatch.addEventListener('keypress', (e) => {
      const key = e.which || e.keyCode;
      // Enter / spacebar
      if (key === 13 || key === 32) {
        e.preventDefault();
        swatch.click();
      }
    });
  });

  window.addEventListener('resize', debounce(() => {
    sameHeight();
  }, 100));
};
